// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__yCe4O","Items":"SideDrawer_Items__3-5aH","Open":"SideDrawer_Open__1iWD7","Close":"SideDrawer_Close__K4362","Logo":"SideDrawer_Logo__3ib50"};